import { events, ServiceEvents } from './service-bus-topics/events';
import { getDecorators as getPubSubDecorators } from './ServiceBusDecorators';
const packageJson = require('../package.json');

import {
    serviceQueries,
    ServiceQueries,
    ServiceQueriesResponseType
} from './service-bus-topics/queries';
import {
    serviceCommands,
    ServiceCommands,
    ServiceCommandsReturnType
} from './service-bus-topics/commands';
import { root } from 'elc-universal-utils';
import { ServiceBus } from './ServiceBus';

root.versions = root.versions || {};
root.versions[packageJson.name] = packageJson.version;

if (root) {
    // @ts-ignore
    root.GlobalServiceBus = new ServiceBus<
        ServiceEvents,
        ServiceQueries,
        ServiceQueriesResponseType,
        ServiceCommands,
        ServiceCommandsReturnType
    >();
}

if (root) {
    root.ServiceBusTopics = {
        commands: serviceCommands,
        events,
        queries: serviceQueries
    };
}

// @ts-ignore
const GlobalServiceBus: ServiceBus<
    ServiceEvents,
    ServiceQueries,
    ServiceQueriesResponseType,
    ServiceCommands,
    ServiceCommandsReturnType
> = root.GlobalServiceBus;

const {
    command,
    commandProvider,
    query,
    watchQuery,
    queryProvider,
    emit,
    on
} = getPubSubDecorators<
    ServiceEvents,
    ServiceQueries,
    ServiceQueriesResponseType,
    ServiceCommands,
    ServiceCommandsReturnType
>(GlobalServiceBus);

export {
    GlobalServiceBus,
    command,
    commandProvider,
    query,
    watchQuery,
    queryProvider,
    emit,
    on,
    serviceQueries,
    ServiceEvents,
    ServiceQueries,
    ServiceQueriesResponseType,
    ServiceCommands,
    ServiceCommandsReturnType,
    serviceCommands,
    events
};

const ElcServiceBus = {
    GlobalServiceBus,
    command,
    commandProvider,
    query,
    watchQuery,
    queryProvider,
    emit,
    on,
    serviceQueries,
    serviceCommands,
    events
};

export { ElcServiceBus };

export { ServiceBus, IQueryProvider } from './ServiceBus';
export { getDecorators } from './ServiceBusDecorators';
